import {createContext} from 'react';

// Snapshot of Cognito user attributes (given_name, family_name, email,
// custom:company_name, custom:tier, custom:account_id). The provider in
// src/providers/UserAttributesProvider.tsx fetches them after sign-in.
// AppLayout reads `email` to decide UserLayout vs PublicLayout.
//
// ⚠️ `accountId` IS `custom:account_id`, NOT the Cognito `sub`. They are
// two different identifiers and neither derives from the other — see
// `docs/API_ENTITY_SEAM_MAP.md` §2, where confusing them is named this
// platform's most expensive bug class. UserAccountProvider feeds this
// value to console-api's `getAccount(id:)`, which keys on the account id.
export type UserAttributesContextType = {
    givenName: string;
    familyName: string;
    name: string;
    email: string;
    companyName: string;
    tier: string;
    accountId: string;
};

export const UserAttributesContext = createContext<UserAttributesContextType>({
    givenName: '',
    familyName: '',
    name: '',
    email: '',
    companyName: '',
    tier: '',
    accountId: '',
});
